import React, { useMemo, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import {
  baseStyle,
  focusedStyle,
  acceptStyle,
  rejectStyle,
  thumb,
  thumbInner,
  img,
  thumbsContainer,
  containerFile,
  alingDiv
} from "./styles";
import { ToastMessage } from "./../ToastMessage";

const maxLength = 2;
function nameLengtValidator(file) {
  if (file.name.length < maxLength) {
    return {
      code: "Advertencia",
      message: "El nombre del archivo debe tener 12 caracteres o mas"
    };
  }
  return null;
}
const UploadInput = (props) => {
  const { maxFiles = 4, files = [], setFiles = () => { }, multiple = true, accept = '.jpeg,.png,.jpg,.webp', isPreview = true } = props;
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    maxFiles: maxFiles,
    maxSize: 4214839,
    multiple: multiple,
    accept: accept,
    validator: nameLengtValidator,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt={file.name} />
      </div>
    </div>
  ));

  const listName = files.map((file) => (
    <div key={file.name}>
      <p>{file.name}</p>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    // console.log("archivos effect", files)
    // console.log("acepted File", acceptedFiles)
    return () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    }

  }, [acceptedFiles, files]);

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  fileRejections.forEach(({ file, errors }) => {
    errors.forEach((e) => {
      ToastMessage.fire({
        icon: "warning",
        title: ` ${e.code}`,
        text: `El archivo ${file.name} ${e.code} ${e.message}`,
      });
    })
  })
  // const fileRejectionItems = fileRejections.map(({file, errors}) =>(
  //   <li key={file.path}>
  //   {file.path} - {file.size} bytes
  //   <ul>
  //     {errors.map(e =>(
  //       <li key={e.code}>{e.message}</li>
  //     ))}
  //   </ul>
  // </li>
  // ))

  return (
    <section style={containerFile}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p>
          Arrastre y suelte algunos archivos aquí, o haga clic para seleccionar
          archivos
        </p>
      </div>
      {
        isPreview && <aside style={alingDiv}>
          <h4>Imagenes</h4>
          <aside style={thumbsContainer}>{thumbs}</aside>
        </aside>
      }
      {
        !isPreview && <aside style={alingDiv}>
          <h4>Archivo</h4>
          {listName}
        </aside>
      }
    </section>
  );
};
export default UploadInput;
